import { writable } from 'svelte/store';

export const currentThemeName = writable();
export const currentThemeObject = writable();
export const themes = writable();
